import React from "react";
import {
  Box,
  Container,
  makeStyles,
} from "@material-ui/core";
import AssignmentReturnedIcon from "@material-ui/icons/AssignmentReturned";

import Page from "src/components/Page";
import View from "./View";
import PageHeader from "../../components/PageHeader";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f7f7fa",
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },

  content: {
    marginTop: theme.spacing(3),
  },
}));

const EventView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Releasing Item Report"
    >
      <Container maxWidth="lg">
        <PageHeader
          icon={<AssignmentReturnedIcon />}
          title="Releasing Item Report"
          subtitle="View and manage item releasing records"
          showSession
        />

        <Box className={classes.content}>
          <View />
        </Box>
      </Container>
    </Page>
  );
};

export default EventView;